import { UtilArray } from './UtilArray';
function filterDuplicates(includeNames) {
    const filtered = [];
    for (let i = 0; i < includeNames.length; i++) {
        const includeName = includeNames[i];
        if (!UtilArray.contains(filtered, includeName)) {
            filtered.push(includeName);
        }
    }
    return filtered;
}
function getIncludeNames(ruleFlow) {
    if (ruleFlow) {
        const includeNames = [];
        const exp = /[\t ]*[\#]include\s+\".*\"/mg;
        let syntax;
        while ((syntax = exp.exec(ruleFlow)) !== null) {
            if (syntax) {
                const exp2 = new RegExp('[\'\"](.*)[\'\"]');
                const includeName = exp2.exec(syntax)[1];
                includeNames.push(includeName);
            }
        }
        return includeNames;
    }
    return [];
}
export class UtilIncludeRuleSet {
    static getIncludeNames(ruleFlow) {
        const includeNames = getIncludeNames(ruleFlow);
        return [].concat(filterDuplicates(includeNames));
    }
    static getDuplicateIncludes(ruleFlow) {
        const includeNames = getIncludeNames(ruleFlow);
        const filtered = [];
        for (let i = 0; i < includeNames.length; i++) {
            const includeName = includeNames[i];
            if (!UtilArray.contains(filtered, includeName)) {
                filtered.push(includeName);
            }
            else {
                return includeName;
            }
        }
        return null;
    }
}
